import {UI, type PartialOptions} from "../../stem-core/ui/UIBase";
import {styleRule, StyleSheet} from "../../stem-core/ui/Style";
import {registerStyle} from "../../stem-core/ui/style/Theme";


export class ScrollableBodyStyle extends StyleSheet {
    @styleRule
    topShadow = {
        position: "sticky",
        top: 0,
        width: "100%",
        boxShadow: "0px 0px 5px 1px rgba(0,0,0,0.24)",
        zIndex: 1,
    }

    @styleRule
    topShadowCover = {
        background: this.themeProps.MERCHANT_FRAME_BACKGROUND,
        position: "absolute",
        width: "100%",
        height: 7,
        zIndex: 2
    }

    @styleRule
    bottomShadow = {
        position: "sticky",
        bottom: 0,
        width: "100%",
        boxShadow: "0px 0px 5px 3px rgba(0,0,0,0.24)",
        zIndex: 1,
    }

    @styleRule
    bottomShadowCover = {
        position: "relative",
        background: this.themeProps.MERCHANT_FRAME_BACKGROUND,
        width: "100%",
        height: 8,
        zIndex: 2
    }
}

interface ScrollableBodyOptions {
    hasShadow?: boolean;
}

@registerStyle(ScrollableBodyStyle)
export class ScrollableBody extends UI.Element<ScrollableBodyOptions> {
    getDefaultOptions(): PartialOptions<ScrollableBody> {
        return {
            hasShadow: true
        };
    }

    shouldDisplayShadow() {
        return this.options.hasShadow;
    }

    renderTopShadow() {
         const {styleSheet} = this;

         return this.shouldDisplayShadow() && [
            <div className={styleSheet.topShadow} />,
            <div className={styleSheet.topShadowCover} />
         ];
    }

    renderBottomShadow() {
         const {styleSheet} = this;

         return this.shouldDisplayShadow() && [
             <div className={styleSheet.bottomShadowCover} />,
             <div className={styleSheet.bottomShadow} />
         ];
    }

    getChildrenToRender() {
        return [
            this.renderTopShadow(),
            this.render(),
            this.renderBottomShadow()
        ]
    }
}